import React from 'react'; // eslint-disable-line
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import MultiSelect from 'react-multi-select-component';
import _actions from '../../actions';
import constants from '../../constants';
import VersionBox from '../../components/common/VersionBox';
import EditInput from '../../components/forms/EditInput';
import GeneralSection from '../../components/common/GeneralSection';
import HorizontalFormContainer from '../../components/forms/HorizontalFormContainer';
import OnOffSwitch from '../../components/forms/OnOffSwitch';
import DisplayOptionsBox from '../../components/forms/DisplayOptionsBox';
import ManagedInput from '../../components/forms/ManagedInput';
import i18n from '../../i18n';
import HelpTooltip from '../../components/common/HelpTooltip';
import GreenCheck from '../../components/svg/GreenCheck';
import Exclamation from '../../components/svg/Exclamation';
import UserSelectedIconSelect from '../../components/pages/UserSelectedIconSelect';

export class CalendarModule extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoaded: false,
            menuItem: {},
            module: {},
            showPreview: true,
        };
    }

    componentDidMount() {
        this.props.actions.getChmsCalendarFeeds();
        this.props.actions.getProjectVersion(this.props.match.params.projectId);
        this.props.actions.getProjectVersionMenuItems(this.props.match.params.projectId);
        this.props.actions.getProjectVersionModules(this.props.match.params.projectId);
        this.props.actions.getModuleByType(this.props.match.params.projectId, constants.ModuleType.find((mt) => { return mt.Name === 'Calendar'; }).Id);
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.modules.select.id
          && this.props.modules.select.moduleType === constants.ModuleType.find((m) => { return m.Name === 'Calendar'; }).Id
          && this.props.modules.select.enabled) {
            if (this.props.alerts.data.length > 0 && this.props.alerts.data.find((m) => { return m.id === 'module-disabled'; })) {
                this.props.actions.clearAlert('module-disabled');
            }
        }
        if (!prevState.isLoaded) {
            if (this.props.modules.select.id
              && this.props.modules.select.moduleType === constants.ModuleType.find((m) => { return m.Name === 'Calendar'; }).Id
              && !this.props.modules.select.enabled) {
                this.props.actions.addAlert({
                    message: i18n.t('modules.calendar.error1'),
                    linkText: i18n.t('enableHere'),
                    link: `/projects/${this.props.match.params.projectId}/modules/enable-modules`,
                    view: '/modules/calendar',
                    type: 'warning',
                    id: 'module-disabled',
                });
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({ isLoaded: true });
            }
        }
        if ((!this.props.menuItems.inProgress
            && prevProps.menuItems.inProgress)
            || (!this.props.modules.inProgress
                && prevProps.modules.inProgress)) {
            let menuItem = this.props.menuItems.data !== []
            && typeof (this.props.modules.select.moduleType) === 'number'
                ? this.props.menuItems.data
                    .find((mi) => {
                        return mi.type === 1
                            && parseInt(mi.subType, 10) === this.props.modules.select.moduleType;
                    })
                : '';
            menuItem = menuItem || {};
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({ menuItem });
        }
        if (!this.props.modules.inProgress && prevProps.modules.inProgress) {
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({ module: this.props.modules.select });
        }
    }

  updateCalendarFormOption = (selected) => {
      const newones = selected.filter((m) => { return m !== ''; }).map((m) => { return m.value; });
      this.setState((prevState) => {
          return { module: { ...prevState.module, calendarFeeds: newones } };
      });
      this.updateModuleFieldWithValue('calendarFeeds', newones);
  }

  updateMenuItemFromEvent = (evt) => {
      const fieldName = evt.target.name;
      const changedValue = evt.target.value.trim().length > 0 ? evt.target.value.trim() : i18n.t('modules.calendar.title');
      if (changedValue !== '') {
          this.setState((prevState) => {
              return {
                  menuItem: {
                      ...prevState.menuItem,
                      title: changedValue,
                  },
              };
          });
          this.props.actions.updateMenuItemParameter(
              this.props.match.params.projectId,
              this.state.module.moduleType,
              1,
              fieldName,
              changedValue,
          );
      }
  }

  updateModuleFieldWithValue = (field, val) => {
      this.props.actions.updateModuleParameter(
          this.props.match.params.projectId,
          this.state.module.moduleType,
          field,
          val,
      );
  }

    updateImagesEnabled = (evt) => {
        const changedValue = evt.target.checked;
        if (changedValue) {
            this.updateModuleFieldWithValue('imagesEnabled', true);
            this.setState((prevState) => {
                return { module: { ...prevState.module, imagesEnabled: true } };
            });
        } else {
            this.updateModuleFieldWithValue('imagesEnabled', false);
            this.setState((prevState) => {
                return { module: { ...prevState.module, imagesEnabled: false } };
            });
        }
    }

  updateModuleFromEvent = (evt) => {
      const changedValue = evt.target.checked;
      if (changedValue) {
          this.updateModuleFieldWithValue('chmsFeedsEnabled', true);
          if (this.props.calendar.feeds.length === 1) {
              this.setState((prevState) => {
                  return {
                      module: {
                          ...prevState.module,
                          calendarFeeds: [this.props.calendar.feeds[0].url],
                      },
                  };
              });
              this.updateModuleFieldWithValue('calendarFeeds', [this.props.calendar.feeds[0].url]);
          }
          this.setState((prevState) => {
              return { module: { ...prevState.module, chmsFeedsEnabled: true } };
          });
      } else {
          this.updateModuleFieldWithValue('chmsFeedsEnabled', false);
          this.setState((prevState) => {
              return {
                  module:
                      { ...prevState.module, chmsFeedsEnabled: false, calendarFeeds: [] },
              };
          });
      }
  }

  connectIcalFeed = () => {
      if (this.state.module.icalFeedUrl !== null || this.state.module.icalFeedUrl !== '') this.updateModuleFieldWithValue('icalFeedUrl', this.state.module.icalFeedUrl);
  };

  disconnectIcalFeed = () => {
      this.updateModuleFieldWithValue('icalFeedUrl', '');
      this.setState((prevState) => { return { module: { ...prevState.module, icalFeedUrl: '' } }; });
  }

  isUnity(){
    const isUnity = localStorage.getItem('IsUnity');
    if (isUnity === 'true'){
        return true;  
    }
    else{
        return false; 
    }
  }
  checkForPeopleModule(){
    const modules = localStorage.getItem('ModulesData');
    const parsedModules = JSON.parse(modules); 
    if (parsedModules !== null && parsedModules !== undefined){
        const hasPeople = parsedModules.find(e => e.name === 'People');
        if(hasPeople !== undefined){
            return true; 
        }
        return false; 
    } 
  }
  disableCalendarFeedToggle(unity, people){
    if(unity === true && people === true){
        return false; 
    }
    else if(unity === true && people === false){
        return true; 
    }
    else{
        return !this.props.versions.select.chMSIntegrations;   
    } 
  }
  isToggleOn(unity,people){
    if(unity === true && people === true){
        return true; 
    }
    else if(unity === true && people === false){
        return false; 
    }
    else{
        return this.state.module.chmsFeedsEnabled; 
    } 
  }
  render() {
      const isUnity = this.isUnity(); 
      const hasPeople = this.checkForPeopleModule(); 
      const isDisabled = this.disableCalendarFeedToggle(isUnity, hasPeople);
      const isToggled = this.isToggleOn(isUnity, hasPeople); 
      const previewCalendar = null;
      const chmsCalendarOptions = this.props.calendar.feeds
          .map((m) => { return { value: m.url, label: m.name }; });
      const selectedOptions = chmsCalendarOptions
          .filter((m) => { return this.state.module.calendarFeeds?.includes(m.value); });
      // Add these back when we add back live preview for Calendar
      // let activeCheckin = this.props.modules.data
      // .filter(module => module.moduleType === constants.ModuleType
      // .find(m => m.Name === 'Check-In').Id);
      // activeCheckin = activeCheckin.filter(module => module.enabled === true);
      const bodyForm = (
          <div className="form-wrapper">
              <h1 data-qa="calendar-page-header" id="calendar-page-header">{i18n.t('modules.calendar.title')}</h1>

              <p data-qa="calendar-page-subhead" id="calendar-page-subhead" className="lead">{i18n.t('modules.calendar.subtitle')}</p>

              <GeneralSection
                  name={i18n.t('modules.calendar.section1')}
                  sectionClass="edit-module-name module-display-settings-list"
              >
                  <div
                      id="module-display-setting"
                      className="module-display-setting"
                  >

                      <EditInput
                          containerId="edit-module-name"
                          containerClass="edit-module-name-wrap"
                          name="title"
                          labelText={i18n.t('name')}
                          value={this.state.menuItem !== {} && this.state.menuItem.title
                              ? this.state.menuItem.title
                              : ''}
                          charLimit={12}
                          onBlur={this.updateMenuItemFromEvent}
                          onReturnDown={this.updateMenuItemFromEvent}
                          actionClass="edit-module-name-action"
                          placeholder={i18n.t('modules.calendar.title')}
                          dataqa="calendar-module-name"
                          menuTitle
                      />
                      {this.props.flags.results?.userSelectedIcons
                      && (
                          <HorizontalFormContainer
                              inputClass="module-display-setting__setting"
                              title="Menu Icon"
                          >
                              <UserSelectedIconSelect
                                  id={this.state.menuItem.subType}
                                  type={this.state.menuItem.type}
                                  autoUpdate
                              />
                          </HorizontalFormContainer>
                      )}
                  </div>

              </GeneralSection>
              <GeneralSection
                  sectionClass="module-display-settings-list"
                  dataqa="module-display-settings"
              >
                  <div data-qa="module-display-setting" id="module-display-setting" className={`module-display-setting ${this.state.module.chmsFeedsEnabled ? 'module-setting-on' : ''}`}>

                      {this.props.flags.results?.chMSIntegration
            && (
                <div className="module-display-setting__setting">
                    <h3>
                        {i18n.t('modules.calendar.section2')}
                        {' '}
                        <HelpTooltip
                            name="sccrmCalendar"
                            tooltipText={i18n.t('modules.calendar.section2help')}
                        />
                    </h3>
                </div>
            )}

                      {this.props.flags.results?.chMSIntegration
            && (
                <HorizontalFormContainer
                    inputClass="module-display-setting__setting"
                    title={i18n.t('modules.calendar.section2toggle')}
                >
                    <OnOffSwitch
                        id="chmsFeedsEnabled"
                        buttonClass="toggle checkbox md-checkbox large-switch"
                        isToggleOn={isToggled}
                        name="chmsFeedsEnabled"
                        onChange={this.updateModuleFromEvent}
                        dataQA="chmsFeedsEnabled"
                        disabled={isDisabled}
                        tooltipText={i18n.t('modules.enable.sccrm-module-help')}
                    />
                </HorizontalFormContainer>
            )}
                      {this.props.flags.results?.chMSIntegration
                      && this.state.module.chmsFeedsEnabled

            && (
                <>
                    <DisplayOptionsBox title={i18n.t('modules.calendar.section2label')}>
                        {chmsCalendarOptions.length === 0
                        && (
                            <div className="calendar-error">
                                <Exclamation color="#C84040" />
                                {i18n.t('modules.calendar.section2error')}
                            </div>
                        )}
                        {chmsCalendarOptions.length === 1
                        && (
                            <div className="calendar-display">
                                {chmsCalendarOptions[0].label}
                            </div>
                        )}
                        {chmsCalendarOptions.length > 1
                        && (
                            <MultiSelect
                                options={chmsCalendarOptions}
                                value={selectedOptions}
                                onChange={this.updateCalendarFormOption}
                                disableSearch
                                hasSelectAll={false}
                            />
                        )}
                    </DisplayOptionsBox>
                    <OnOffSwitch
                        id="enabled-images"
                        buttonClass="toggle checkbox md-checkbox"
                        isToggleOn={this.state.module.imagesEnabled}
                        name="imagesEnabled"
                        onChange={this.updateImagesEnabled}
                        dataQA="images-enabled"
                    />
                    {i18n.t('modules.calendar.imageToggle')}
                </>
            )}
                      <div className="module-display-setting__setting icalheading">
                          <h3>{i18n.t('modules.calendar.section3')}</h3>
                      </div>
                      { (!this.props.modules.select.icalFeedUrl
                                  || this.props.modules.select.icalFeedUrl === '')
                          ? (

                              <HorizontalFormContainer
                                  inputClass="module-display-setting__setting wrappable icalwrapper"
                                  title={i18n.t('modules.calendar.section3label')}
                              >
                                  <div id="icalFeed" className="form-control">
                                      <ManagedInput
                                          type="text"
                                          placeholder={i18n.t('modules.calendar.section3placeholder')}
                                          name="icalFeed"
                                          onBlur={(e) => {
                                              const target = e.target.value;
                                              this.setState((prevState) => {
                                                  return {
                                                      module: {
                                                          ...prevState.module,
                                                          icalFeedUrl: target,
                                                      },
                                                  };
                                              });
                                          }}
                                          value={this.state.module.icalFeedUrl}
                                          autoFocus={false}
                                          dataqa="calendar-icalFeed"
                                      />

                                      {/* eslint-disable-next-line react/button-has-type */}
                                      <button
                                          data-qa="connect-ical-button"
                                          id="connect-ical"
                                          className="btn btn-sq btn-outline btn-sm dialog-launcher"
                                          onClick={this.connectIcalFeed}
                                      >
                                          {i18n.t('connect')}
                                      </button>
                                  </div>
                              </HorizontalFormContainer>
                          )
                          : (

                              <HorizontalFormContainer
                                  inputClass="module-display-setting__setting wrappable icalwrapper"
                              >
                                  <div id="icalFeed" className="form-control">
                                      <h4 data-qa="ical-feed-label">
                                          <GreenCheck />
                                          {' '}

                                          iCal Feed
                                      </h4>
                                      {/* eslint-disable-next-line react/button-has-type */}
                                      <button
                                          data-qa="disconnect-ical-button"
                                          id="disconnect-ical"
                                          className="btn btn-sq btn-outline btn-sm dialog-launcher"
                                          onClick={this.disconnectIcalFeed}
                                      >
                                          {i18n.t('disconnect')}
                                      </button>
                                      <p data-qa="ical-feed-url">{this.state.module.icalFeedUrl}</p>

                                  </div>
                              </HorizontalFormContainer>
                          ) }
                  </div>

              </GeneralSection>
          </div>
      );

      return (
          <VersionBox
              name={this.props.versions.select.name}
              versionNumber={this.props.versions.select.version}
              saving={this.props.modules.inProgress}
              justSaved={this.props.modules.justSaved}
              menuSection="Modules"
              menuItem="CalendarModule"
              previewCssClass="modules_calendar"
              previewChild={previewCalendar}
              showPreview={this.state.showPreview}
              x
          >
              <div id="calendar-module" className="content-inside">
                  {bodyForm}
              </div>
          </VersionBox>

      );
  }
}

const mapStateToProps = (state, ownProps) => {
    return {
        ...state,
        ...ownProps,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(_actions, dispatch),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(CalendarModule);
